import { GpuListing } from "../types/GpuListing";

export const mockListings: GpuListing[] = [
  {
    id: 1,
    full_name: "ASUS TUF Gaming GeForce RTX 5070 Ti OC Edition 16GB GDDR7",
    variant_name: "TUF Gaming OC",
    manufacturer: "ASUS",
    price: 7649,
    original_price: 8499,
    retailer: "Webhallen",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 2,
    full_name: "MSI GeForce RTX 5070 Ti Gaming X Trio 16GB GDDR7",
    variant_name: "Gaming X Trio",
    manufacturer: "MSI",
    price: 8799,
    original_price: 0,
    retailer: "Komplett",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 3,
    full_name: "Gigabyte GeForce RTX 5070 Ti Eagle OC 16GB GDDR7",
    variant_name: "Eagle OC",
    manufacturer: "Gigabyte",
    price: 7999,
    original_price: 0,
    retailer: "Inet",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "out_of_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 4,
    full_name: "EVGA GeForce RTX 5070 Ti FTW3 Ultra Gaming 16GB GDDR7",
    variant_name: "FTW3 Ultra",
    manufacturer: "EVGA",
    price: 8279,
    original_price: 9199,
    retailer: "Proshop",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 5,
    full_name: "Zotac Gaming GeForce RTX 5070 Ti AMP Extreme Holo 16GB GDDR7",
    variant_name: "AMP Extreme",
    manufacturer: "Zotac",
    price: 8299,
    original_price: 0,
    retailer: "Webhallen",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 6,
    full_name: "Palit GeForce RTX 5070 Ti GamingPro 16GB GDDR7",
    variant_name: "GamingPro",
    manufacturer: "Palit",
    price: 7799,
    original_price: 0,
    retailer: "Komplett",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "out_of_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 7,
    full_name: "ASUS ROG Strix GeForce RTX 5070 Ti OC Edition 16GB GDDR7",
    variant_name: "ROG Strix OC",
    manufacturer: "ASUS",
    price: 8549,
    original_price: 9499,
    retailer: "Inet",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 8,
    full_name: "MSI GeForce RTX 5070 Ti Ventus 3X OC 16GB GDDR7",
    variant_name: "Ventus 3X OC",
    manufacturer: "MSI",
    price: 8199,
    original_price: 0,
    retailer: "Proshop",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 9,
    full_name: "Gigabyte GeForce RTX 5070 Ti AORUS Master 16GB GDDR7",
    variant_name: "AORUS Master",
    manufacturer: "Gigabyte",
    price: 8999,
    original_price: 9799,
    retailer: "Amazon",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 10,
    full_name: "ASUS Dual GeForce RTX 5070 Ti OC 16GB GDDR7",
    variant_name: "Dual OC",
    manufacturer: "ASUS",
    price: 7499,
    original_price: 0,
    retailer: "Elgiganten",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 11,
    full_name: "MSI GeForce RTX 5070 Ti Suprim X 16GB GDDR7",
    variant_name: "Suprim X",
    manufacturer: "MSI",
    price: 9199,
    original_price: 9999,
    retailer: "CsMegastore",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "incoming",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 12,
    full_name: "Zotac Gaming GeForce RTX 5070 Ti Trinity OC 16GB GDDR7",
    variant_name: "Trinity OC",
    manufacturer: "Zotac",
    price: 7899,
    original_price: 0,
    retailer: "Amazon",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 13,
    full_name: "Palit GeForce RTX 5070 Ti JetStream OC 16GB GDDR7",
    variant_name: "JetStream OC",
    manufacturer: "Palit",
    price: 8099,
    original_price: 8699,
    retailer: "Elgiganten",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 14,
    full_name: "Gigabyte GeForce RTX 5070 Ti Gaming OC 16GB GDDR7",
    variant_name: "Gaming OC",
    manufacturer: "Gigabyte",
    price: 7799,
    original_price: 0,
    retailer: "CsMegastore",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "out_of_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 15,
    full_name: "ASUS ProArt GeForce RTX 5070 Ti OC 16GB GDDR7",
    variant_name: "ProArt OC",
    manufacturer: "ASUS",
    price: 8399,
    original_price: 0,
    retailer: "Webhallen",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 16,
    full_name: "MSI GeForce RTX 5070 Ti Gaming Slim 16GB GDDR7",
    variant_name: "Gaming Slim",
    manufacturer: "MSI",
    price: 7699,
    original_price: 8199,
    retailer: "Komplett",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 17,
    full_name: "Gigabyte GeForce RTX 5070 Ti Windforce OC 16GB GDDR7",
    variant_name: "Windforce OC",
    manufacturer: "Gigabyte",
    price: 7599,
    original_price: 0,
    retailer: "Inet",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 18,
    full_name: "EVGA GeForce RTX 5070 Ti XC3 Gaming 16GB GDDR7",
    variant_name: "XC3 Gaming",
    manufacturer: "EVGA",
    price: 7949,
    original_price: 0,
    retailer: "Proshop",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "incoming",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 19,
    full_name: "Zotac Gaming GeForce RTX 5070 Ti Twin Edge OC 16GB GDDR7",
    variant_name: "Twin Edge OC",
    manufacturer: "Zotac",
    price: 7449,
    original_price: 0,
    retailer: "Amazon",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 20,
    full_name: "Palit GeForce RTX 5070 Ti StormX 16GB GDDR7",
    variant_name: "StormX",
    manufacturer: "Palit",
    price: 7399,
    original_price: 7899,
    retailer: "Elgiganten",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 21,
    full_name: "ASUS TUF Gaming GeForce RTX 5070 Ti 16GB GDDR7",
    variant_name: "TUF Gaming",
    manufacturer: "ASUS",
    price: 7349,
    original_price: 0,
    retailer: "CsMegastore",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "out_of_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 22,
    full_name: "MSI GeForce RTX 5070 Ti Gaming X Slim 16GB GDDR7",
    variant_name: "Gaming X Slim",
    manufacturer: "MSI",
    price: 8399,
    original_price: 8899,
    retailer: "Webhallen",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 23,
    full_name: "Gigabyte GeForce RTX 5070 Ti AORUS Elite 16GB GDDR7",
    variant_name: "AORUS Elite",
    manufacturer: "Gigabyte",
    price: 8199,
    original_price: 0,
    retailer: "Komplett",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 24,
    full_name: "EVGA GeForce RTX 5070 Ti FTW3 Gaming 16GB GDDR7",
    variant_name: "FTW3 Gaming",
    manufacturer: "EVGA",
    price: 7999,
    original_price: 8599,
    retailer: "Inet",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 25,
    full_name: "Zotac Gaming GeForce RTX 5070 Ti AMP Core 16GB GDDR7",
    variant_name: "AMP Core",
    manufacturer: "Zotac",
    price: 7749,
    original_price: 0,
    retailer: "Proshop",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "unknown",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 26,
    full_name: "Palit GeForce RTX 5070 Ti Dual OC 16GB GDDR7",
    variant_name: "Dual OC",
    manufacturer: "Palit",
    price: 7599,
    original_price: 0,
    retailer: "Amazon",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 27,
    full_name: "ASUS KO GeForce RTX 5070 Ti OC 16GB GDDR7",
    variant_name: "KO OC",
    manufacturer: "ASUS",
    price: 7299,
    original_price: 7799,
    retailer: "Elgiganten",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 28,
    full_name: "MSI GeForce RTX 5070 Ti Ventus 2X OC 16GB GDDR7",
    variant_name: "Ventus 2X OC",
    manufacturer: "MSI",
    price: 7899,
    original_price: 0,
    retailer: "CsMegastore",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "incoming",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 29,
    full_name: "Gigabyte GeForce RTX 5070 Ti Vision OC 16GB GDDR7",
    variant_name: "Vision OC",
    manufacturer: "Gigabyte",
    price: 8499,
    original_price: 8999,
    retailer: "Webhallen",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 30,
    full_name: "EVGA GeForce RTX 5070 Ti XC Gaming 16GB GDDR7",
    variant_name: "XC Gaming",
    manufacturer: "EVGA",
    price: 7699,
    original_price: 0,
    retailer: "Komplett",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "out_of_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 31,
    full_name: "Zotac Gaming GeForce RTX 5070 Ti Solid 16GB GDDR7",
    variant_name: "Solid",
    manufacturer: "Zotac",
    price: 7349,
    original_price: 0,
    retailer: "Inet",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 32,
    full_name: "Palit GeForce RTX 5070 Ti GamingPro OC 16GB GDDR7",
    variant_name: "GamingPro OC",
    manufacturer: "Palit",
    price: 7999,
    original_price: 8499,
    retailer: "Proshop",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 33,
    full_name: "ASUS Phoenix GeForce RTX 5070 Ti OC 16GB GDDR7",
    variant_name: "Phoenix OC",
    manufacturer: "ASUS",
    price: 7549,
    original_price: 0,
    retailer: "Amazon",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 34,
    full_name: "MSI GeForce RTX 5070 Ti Armor OC 16GB GDDR7",
    variant_name: "Armor OC",
    manufacturer: "MSI",
    price: 7649,
    original_price: 0,
    retailer: "Elgiganten",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "unknown",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 35,
    full_name: "Gigabyte GeForce RTX 5070 Ti Eagle 16GB GDDR7",
    variant_name: "Eagle",
    manufacturer: "Gigabyte",
    price: 7299,
    original_price: 0,
    retailer: "CsMegastore",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 36,
    full_name: "EVGA GeForce RTX 5070 Ti Black Gaming 16GB GDDR7",
    variant_name: "Black Gaming",
    manufacturer: "EVGA",
    price: 7399,
    original_price: 7899,
    retailer: "Webhallen",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 37,
    full_name: "Zotac Gaming GeForce RTX 5070 Ti Destroyer 16GB GDDR7",
    variant_name: "Destroyer",
    manufacturer: "Zotac",
    price: 7249,
    original_price: 0,
    retailer: "Komplett",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "out_of_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 38,
    full_name: "Palit GeForce RTX 5070 Ti Infinity 16GB GDDR7",
    variant_name: "Infinity",
    manufacturer: "Palit",
    price: 8699,
    original_price: 9199,
    retailer: "Inet",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 39,
    full_name: "ASUS ROG Strix GeForce RTX 5070 Ti White OC 16GB GDDR7",
    variant_name: "ROG Strix White",
    manufacturer: "ASUS",
    price: 8999,
    original_price: 0,
    retailer: "Proshop",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "incoming",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
  {
    id: 40,
    full_name: "MSI GeForce RTX 5070 Ti Sea Hawk X 16GB GDDR7",
    variant_name: "Sea Hawk X",
    manufacturer: "MSI",
    price: 9499,
    original_price: 10499,
    retailer: "Amazon",
    url: "#",
    image_url:
      "https://images.netonnet.com/rs/w:1920/q:75/f:webp/plain/https://www.netonnet.se/GetFile/ProductImagePrimary/(1054560)_714038_extra.webp",
    stock_status: "in_stock",
    last_checked: new Date().toISOString(),
    created_at: new Date().toISOString(),
  },
];
